import {createApi} from './api'
import {ApiContextProvider} from './hooks'
import {KilnConfig} from './modules/kilnConfig'

export const KilnConfigApp = () => {
  const api = createApi()

  return (
    <ApiContextProvider axiosInstance={api.axiosInstance}>
      <KilnConfig />
    </ApiContextProvider>
  )
}
